import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=b4b96ba0&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=js&"
export * from "./Players.vue?vue&type=script&lang=js&"
import style0 from "./Players.vue?vue&type=style&index=0&id=b4b96ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b96ba0",
  null
  
)

export default component.exports